
import {Component, Prop, Vue} from 'vue-property-decorator';
import {SweetModal} from 'sweet-modal-vue';
import NevronInput from '@/components/NevronInput.vue';
import { bus } from '@/helpers/functions';

@Component({
  components: {
    SweetModal,
    NevronInput,
  },
})
export default class CollectionItem extends Vue {
  @Prop()
  dashboardName: any;
  @Prop()
  dashboardId: any;

  mounted() {
    console.log('dashboardId', this.dashboardId);
  }

  openTranslator(localText: any, localKey: any, referenceKey: any) {
    bus().$emit('openTranslator', localText, localKey, referenceKey);
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
    this.$emit('close', this.dashboardName);
  }

  next() {
    this.$emit('next', this.dashboardName);
    // @ts-ignore
    this.$children[0].close();
  }
}
